import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const FORMS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"forms"> = {};
